module.exports = __webpack_public_path__ + "static/media/quickbooks-brand-preferred-logo.b8eb7e52.png";